import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import AVATable from '../Components/AVATable';
import AVATableCol from '../Components/AVATableCol';
import AVAGrid from '../Components/AVAGrid';



class GenericView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      count:0
    }
  }

  

  sortHeader = (columnId) =>{
    this.props.sortHeaderActionByColumnId({columnId:columnId,dbLink:this.props.clientActive,menu:this.props.activeMenu,subitem:this.props.activeSubMenu});
    this.setState({count:this.state.count+1});
  }

  render() {
    //console.log("formatedData", this.props.formatedData);
    return (
      <div className="Homepage View">
        <div className="View-content">
          <div className="View-header">
            <h1 className="View-title">{this.props.activeMenu}{this.props.activeSubMenu != null? " - "+this.props.activeSubMenu:""}</h1>
          </div>
          {
            this.props.activeMenu ==="Home" || this.props.activeMenu ==="/Login"? null :
            this.props.activeSubMenu === null ? <AVAGrid />:<AVATableCol 
            requestName={this.props.activeSubMenu} 
            client={this.props.clientActive}
            data={this.props.formatedData.filter(item=>item.dbLink === this.props.clientActive)[0].requetes.filter(item=>item.name === this.props.activeSubMenu && item.category === this.props.activeMenu)[0]}
            sortHeader={this.sortHeader}
            action={this.state.count}
            />

            // <AVATable 
            // columns={this.props.menuList.filter(item=>item.ITEM===this.props.activeMenu && item.SUBITEM===this.props.activeSubMenu)[0].COLUMN} 
            // menu={this.props.activeMenu} 
            // data={this.props.activeData}
            // sortHeader={this.sortHeader}
            // action={this.state.count}
            // />
          }
          
        </div>
        
      </div>
    );
  }
}
const mapStateToProps = (state) => {    
  return {  
    activeMenu : state.appReducer.activeMenu,
    activeSubMenu : state.appReducer.activeSubMenu,
    menuList: state.apiReducer.menuList,
    activeData:state.apiReducer.activeData,
    formatedData:state.apiReducer.formatedData,
    clientActive:state.apiReducer.clientActive,
    fullScope : state.apiReducer.fullScopeData,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    sortHeaderAction: (data) => dispatch(repositoryActions.sortHeaderAction(data)),
    sortHeaderActionByColumnId: (data) => dispatch(repositoryActions.sortHeaderActionByColumnId(data)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(GenericView);